import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { api } from "@/lib/api";

const cfg = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
const VAPID = process.env.REACT_APP_FIREBASE_VAPID_KEY;
export const pushConfigured = () => Boolean(cfg.apiKey && cfg.projectId && cfg.messagingSenderId && cfg.appId && VAPID);

async function messaging() {
  if (!pushConfigured() || !(await isSupported())) return null;
  const app = getApps()[0] || initializeApp(cfg);
  return getMessaging(app);
}

export async function enablePush() {
  const m = await messaging();
  if (!m) throw new Error("Push notifications aren't available on this browser or aren't set up yet.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications are blocked — allow them in your browser settings.");
  const qs = new URLSearchParams(cfg).toString();
  const reg = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${qs}`);
  const token = await getToken(m, { vapidKey: VAPID, serviceWorkerRegistration: reg });
  if (!token) throw new Error("Could not get a push token.");
  await api.post("/push/register", { token });
  localStorage.setItem("push_token", token);
  return token;
}

export async function listenForeground(onShow) {
  const m = await messaging().catch(() => null);
  if (m && localStorage.getItem("push_token")) onMessage(m, (p) => onShow(p.notification || {}));
}
